import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm text-catering-ink-900 shadow-catering-xs" }
const _hoisted_2 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_3 = { class: "text-[15px] font-semibold" }
const _hoisted_4 = { class: "shrink-0 tabular-nums" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-catering-berry-500"
}
const _hoisted_6 = { class: "mt-2 space-y-1 text-xs" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between gap-3"
}
const _hoisted_8 = { class: "text-catering-ink-700" }
const _hoisted_9 = { class: "flex justify-between gap-3" }
const _hoisted_10 = { class: "text-catering-ink-700" }
const _hoisted_11 = { class: "flex justify-between gap-3" }
const _hoisted_12 = { class: "text-catering-ink-700" }
const _hoisted_13 = {
  key: 1,
  class: "flex justify-between gap-3"
}
const _hoisted_14 = { class: "text-catering-ink-700" }
const _hoisted_15 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_16 = { class: "text-xs font-medium text-catering-ink-800" }
const _hoisted_17 = {
  key: 0,
  class: "text-catering-ink-400"
}
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = { class: "min-w-0 truncate" }
const _hoisted_20 = { class: "shrink-0 tabular-nums" }
const _hoisted_21 = {
  key: 2,
  class: "mt-2 flex flex-wrap gap-1"
}
const _hoisted_22 = {
  key: 3,
  class: "mt-1 flex flex-wrap gap-1"
}

import { computed } from 'vue'

export default {
  __name: 'BotProductDetail',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props
const product = computed(() => props.block.product || {})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(product.value.name), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(product.value.price), 1)
    ]),
    (product.value.status && product.value.status !== 'live')
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(product.value.status), 1))
      : _createCommentVNode("", true),
    _createElementVNode("dl", _hoisted_6, [
      (product.value.sku)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "SKU", -1)),
            _createElementVNode("dd", _hoisted_8, _toDisplayString(product.value.sku), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Inventory", -1)),
        _createElementVNode("dd", _hoisted_10, _toDisplayString(product.value.inventory), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[2] || (_cache[2] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Taxable", -1)),
        _createElementVNode("dd", _hoisted_12, _toDisplayString(product.value.taxable ? 'Yes' : 'No'), 1)
      ]),
      (product.value.max_per_order)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Max per order", -1)),
            _createElementVNode("dd", _hoisted_14, _toDisplayString(product.value.max_per_order), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    ((product.value.variants || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-[11px] font-semibold uppercase tracking-wide text-catering-honey-600" }, "Variants", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.variants, (v, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "mt-1"
            }, [
              _createElementVNode("p", _hoisted_16, [
                _createTextVNode(_toDisplayString(v.name) + " ", 1),
                (v.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "· required"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.options || [], (o, j) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: j,
                    class: "flex justify-between text-xs text-catering-ink-700"
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(o.name), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(o.add_on_price), 1)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    ((product.value.stores || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.stores, (s, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
            }, _toDisplayString(s.store), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    ((product.value.labels || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.labels, (l, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600"
            }, _toDisplayString(l), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}